import { Button, Flex, Modal, Typography } from "antd";
import { useState } from "react";
import { useAppSelector } from "../../hooks/redux-hooks";
import { membersService } from "../../service/members.service";
import { UserTier } from "../../slices/authSlice";

const { Text, Title } = Typography;

const BillingInactiveModal = () => {
  const { userInfo } = useAppSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);

  const isGroupUser = userInfo.tier === UserTier.GROUP;
  const isBillingInactive = isGroupUser && userInfo.group_billing_active === false;
  const isAdmin = userInfo.is_group_admin;

  const handleSetUpBilling = async () => {
    setLoading(true);
    try {
      const { payment_link } = await membersService.generateGroupPaymentLink("monthly");
      window.open(payment_link, "_blank");
    } catch {
      // Fallback: navigate to members page
      window.location.href = "/members";
    } finally {
      setLoading(false);
    }
  };

  if (!isBillingInactive) return null;

  return (
    <Modal open closable={false} footer={null} centered maskClosable={false}>
      <Flex vertical gap={16} align="center" style={{ padding: "16px 0" }}>
        <Title level={4} style={{ margin: 0 }}>
          Subscription Inactive
        </Title>
        {isAdmin ? (
          <>
            <Text style={{ textAlign: "center" }}>
              Your group's billing subscription has lapsed due to a failed payment. Please set up a new subscription to
              restore access for your team.
            </Text>
            <Button type="primary" size="large" loading={loading} onClick={handleSetUpBilling}>
              Set Up Billing
            </Button>
            <Button type="link" href="/members">
              Go to Member Management
            </Button>
          </>
        ) : (
          <>
            <Text style={{ textAlign: "center" }}>
              Your group's subscription is currently inactive. Please contact your group administrator to restore
              access.
            </Text>
            {userInfo.group_name && <Text type="secondary">Group: {userInfo.group_name}</Text>}
          </>
        )}
      </Flex>
    </Modal>
  );
};

export default BillingInactiveModal;
